import { computed } from 'vue';
import { useRoute } from 'vue-router';

/**
 * Resolves layout shell for App.vue (`public` | `minimal` | `tenant-dashboard` | `admin`).
 * See frontend/docs/LAYOUT_SYSTEM_PROPOSAL.md.
 */
export function useEffectiveLayout() {
  const route = useRoute();

  return computed(() => {
    const layout = route.meta.layout;
    if (
      layout === 'public' ||
      layout === 'minimal' ||
      layout === 'tenant-dashboard' ||
      layout === 'admin'
    ) {
      return layout;
    }
    return 'public';
  });
}
